import { WppTag } from '@wppopen/components-library-react'
import { statusChecker } from '../../StatusMessage/Status'
import type { JobsDetailData, ProjectsUpdatePayload } from '@contracts'
import type { ImportsCreateDataV5 } from 'utils/utils.d'
import styles from './statusCell.module.scss'
import stylesTag from '../../StatusMessage/StatusMessage.module.scss'

interface StatusCellProps {
  status: JobsDetailData['status'] | ProjectsUpdatePayload['status'] | ImportsCreateDataV5['status']
  label?: string
  isProject?: boolean
}

function StatusCell({ status, label, isProject, ...props }: StatusCellProps) {
  const dataToRender = statusChecker(status, isProject)

  return (
    <div className={styles.draft_status} {...props}>
      {label ? (
        <WppTag
          label={label}
          variant="neutral"
          className={stylesTag.blue_tag}
          data-testid="status-tag-pending-approval"
        />
      ) : (
        dataToRender.tag
      )}
    </div>
  )
}

export default StatusCell
